import className from '../../constants/classNames-swiper';
import { lngprovider } from '../../constants/languages';

const NotSellable = () => {
  const lng = dataLayer
    ? lngprovider(dataLayer[0].language)
    : lngprovider('de_DE');
  return `
<div class="${className.NOTIFICATION.WRAP}">
    <img class="${
      className.NOTIFICATION.IMG
    }" src="https://cdn.home24.net/shop-app/assets/bdbd2c6/images/icons/info.svg">
    <div class="${className.NOTIFICATION.INNER}">
        ${lng.NOTSELLABLE}
    </div>
</div>
  `;
};

export default NotSellable;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/NotSellable/notsellable.js
 **/